import React, { useCallback, useState } from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const TimeInput = ({ value = {}, period, setPeriod, onChange }) => {
  const [duration, setDuration] = useState(value.duration);

  const triggerChange = (changedValue) => {
    onChange?.({ duration, period, ...value, ...changedValue });
  };

  const onDurationChange = (e) => {
    const newValue = e.target.value;
    setDuration(newValue);
    triggerChange({ duration: newValue });
  };

  const onPeriodChange = (newValue) => {
    setPeriod(newValue);
    triggerChange({ period: newValue });
  };

  return (
    <span>
      <Input
        type="text"
        value={value.duration || duration}
        onChange={onDurationChange}
        max={7776000}
        style={{ width: 100 }}
      />
      <Select
        value={value.period || period}
        style={{ width: 80, margin: '0 8px' }}
        onChange={onPeriodChange}
      >
        <Option value="60">Minutes</Option>
        <Option value="3600">Hours</Option>
        <Option value="86400">Days</Option>
      </Select>
    </span>
  );
};

const FunnelCompletionTime = ({
  setCompletionTimeError,
  executing,
  executionParams,
  updateFunnelExecutionParameters,
}) => {
  const [period, setPeriod] = useState('86400');

  const onChange = (values) => {
    updateFunnelExecutionParameters({
      completionTime:
        parseInt(values.ctime.duration) * parseInt(values.ctime.period),
    });
  };

  const checkValue = useCallback(
    (_, value) => {
      if (value.duration <= 0) {
        setCompletionTimeError(true);
        return Promise.reject(new Error('duration must be greater than zero!'));
      }

      if (value.duration * parseInt(period) > 7776000) {
        setCompletionTimeError(true);
        return Promise.reject(
          new Error('duration must be less than 3 months!')
        );
      }

      setCompletionTimeError(false); // Reset error if checks pass
      return Promise.resolve();
    },
    [period]
  );

  function calculateDurationAndPeriod(completionTime) {
    const daySeconds = 86400;
    if (completionTime % daySeconds === 0) {
      return {
        duration: Math.floor(executionParams.completionTime / daySeconds),
        period: `${daySeconds}`,
      };
    }
    const hourSeconds = 3600;
    if (completionTime % hourSeconds === 0) {
      return {
        duration: Math.floor(executionParams.completionTime / hourSeconds),
        period: `${hourSeconds}`,
      };
    }
    const minuteSeconds = 60;
    if (completionTime % minuteSeconds === 0) {
      return {
        duration: Math.floor(executionParams.completionTime / minuteSeconds),
        period: `${minuteSeconds}`,
      };
    }
  }

  return (
    <div>
      <Form
        name="funnel_report_time"
        layout="inline"
        onValuesChange={onChange}
        initialValues={{
          ctime: calculateDurationAndPeriod(executionParams.completionTime),
        }}
        disabled={executing}
      >
        <Form.Item
          name="ctime"
          label="Completion Time"
          tooltip="The time in which user should reach last step after reaching the first step."
          rules={[{ validator: checkValue }]}
        >
          <TimeInput period={period} setPeriod={setPeriod} />
        </Form.Item>
      </Form>
    </div>
  );
};

export default FunnelCompletionTime;
